import styled from 'react-emotion';
import {Segment} from 'semantic-ui-react';

export const Wrapper = styled.div`
  min-width: 350px;
  max-width: 400px;
  margin: 100px auto 0;
  padding: 0 10px;

  .ui.header > img {
    width: 135px;
    height: 120px;
    margin: 0 0 20px !important;
  }
`;
export const BoxShadow = styled.div`
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
`;
export const FormWrapper = styled(Segment)`
  &.ui.attached.segment {
    padding-top: 20px;
    margin-bottom: 20px;
  }
`;
